import React from "react";
import companyLogo from "../assets/madhumeet-logo.webp";
import "./LoginCompanyBrand.css";

const COMPANY_NAME = "MadhuMeet Meditech LLP";
const TAGLINE = "Healthcare Meets Intelligence";

// Company identity is deliberately separate from tenant/clinic branding.
// It must never replace a clinic name, prescriber identity or printed letterhead.
const CompanyLogo = ({ testId, className }) => (
  <img
    src={companyLogo}
    alt={`${COMPANY_NAME} — ${TAGLINE}`}
    width="1001"
    height="712"
    className={className}
    data-testid={testId}
    decoding="async"
  />
);

export const LoginCompanyPanel = () => (
  <aside className="madhumeet-panel" aria-labelledby="login-company-heading" data-testid="login-company-brand-panel">
    <div className="madhumeet-panel-inner">
      <p className="madhumeet-company-name" data-testid="login-company-title">{COMPANY_NAME}</p>
      <div className="madhumeet-company-story">
        <CompanyLogo testId="login-company-logo" className="madhumeet-company-logo" />
        <div className="madhumeet-company-message">
          <span className="madhumeet-accent-rule" aria-hidden="true" />
          <h1 id="login-company-heading" className="madhumeet-headline" data-testid="login-company-tagline">
            Healthcare Meets<br /><span>Intelligence.</span>
          </h1>
          <p className="madhumeet-company-copy" data-testid="login-company-description">
            Bringing healthcare and technology together,<br className="madhumeet-copy-break" /> with people at the centre.
          </p>
        </div>
      </div>
      <footer className="madhumeet-company-footer">
        <span className="madhumeet-product-name" data-testid="login-company-product">Prescribify</span>
        <span data-testid="login-company-signoff">Technology. With care.</span>
      </footer>
    </div>
  </aside>
);

export const MobileCompanyIdentity = () => (
  <div className="madhumeet-mobile-identity" data-testid="login-mobile-company-header">
    <h1 className="sr-only" data-testid="login-mobile-company-title">{COMPANY_NAME}</h1>
    <CompanyLogo testId="login-mobile-company-logo" className="madhumeet-mobile-logo" />
    <p data-testid="login-mobile-company-tagline">{TAGLINE}</p>
  </div>
);